<template>
  <div class="splitLight">
    
   
  </div>
</template>

<script>
export default {
  name: 'share',
  props: {
  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.splitLight{
  width:100%;
  height:0.01rem;
  background:rgba(0,0,0,1);
  opacity:0.04;
  border: solid 1px;
}
 
</style>
